import React from 'react';
import NewsletterCom from '../resources/Newsletter';
import { WpPage_Flexiblecontent_FlexibleContent_Newsletter } from 'src/_generated/types';

export default function Newsletter({ heading, subheading }: WpPage_Flexiblecontent_FlexibleContent_Newsletter) {
  return (
    <NewsletterCom heading={heading} content={subheading} />
  );
}
